import type { ChatBlock } from "./chat-block.types";

// Legacy adapter. The current chat protocol streams a single markdown string.
// Until the backend emits typed blocks (spec phase 2), wrap that string as one
// text block so the render path is identical for legacy and future responses.
// This is what makes phase 1 a zero-visible-change refactor.
export function stringToBlocks(content: string): ChatBlock[] {
	// Strip the injected page-context tag from display (previously done inline in
	// ChatMessage). Assistant content normally lacks it; this stays defensive.
	const markdown = content.replace(/\[Current Page: .*?\]\s*/g, "");
	// Distinct id namespace so this locally-derived block can never collide with a
	// real stream block's React key when both render in one message.
	return [{ id: "legacy-text", type: "text", markdown }];
}
